import { combineReducers } from 'redux';

import {
  setDocumentForm,
  setDocumentFormsSubmit,
  setDocumentFormsReset,
  removeDocumentForm,
} from '../actions';
import { DocumentAction, StateForms } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof StateForms> = Reducer<StateForms, DocumentAction, T>;

const forms: ReducerOf<'forms'> = (state = null, action) => {
  switch (action.type) {
    case setDocumentForm.type:
      if(state){
        return [...state.filter(item => item.id !== action.payload.id), action.payload]
      }
      return [action.payload];

    case removeDocumentForm.type:
      if(state){
        return state.filter(item => item.id !== action.payload);
      }
      return state;

    default:
      return state;
  }
};

const isSubmit: ReducerOf<'isSubmit'> = (state = false, action) => {
  switch (action.type) {
    case setDocumentFormsSubmit.type:
      return action.payload;

    default:
      return state;
  }
};

const isReset: ReducerOf<'isReset'> = (state = false, action) => {
  switch (action.type) {
    case setDocumentFormsReset.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<StateForms>({
  forms,
  isSubmit,
  isReset,
});
